import {injectable} from 'inversify';

import type {UserModel} from './User.model';

import {BaseController} from '../Base/Base.controller';

@injectable()
export class UserController extends BaseController<UserModel> {
  constructor() {
    super();
  }
}
